import { Timestamp } from 'firebase/firestore';

export type GameType = 
  | 'NLH' // No Limit Hold'em
  | 'PLO' // Pot Limit Omaha
  | 'PLO8' // Pot Limit Omaha 8
  | 'Mixed' // Mixed games
  | 'Stud' // Seven Card Stud
  | 'Razz' // Seven Card Razz
  | 'Stud8' // Seven Card Stud 8
  | 'Custom'; // Custom game type

export type TableStatus = 'Open' | 'Running' | 'Closed' | 'Interest';

export interface Table {
  id: string;
  name: string;
  game_type: GameType;
  custom_game_type?: string; // For custom game types
  stakes: string; // e.g., "$1/$3", "$2/$5", "$5/$10"
  number_of_tables: number;
  status: TableStatus;
  display_order: number; // Controls display order (1, 2, 3...)
  updated_at: Timestamp;
  waitlist_limit?: number; // Override room default if set
}

export interface CreateTableData {
  name: string;
  game_type: GameType;
  custom_game_type?: string;
  stakes: string;
  number_of_tables: number;
  status?: TableStatus;
  display_order?: number; // Optional - will be auto-assigned if not provided
  waitlist_limit?: number;
}

export interface UpdateTableData {
  name?: string;
  game_type?: GameType;
  custom_game_type?: string;
  stakes?: string;
  number_of_tables?: number;
  status?: TableStatus;
  display_order?: number;
  waitlist_limit?: number;
}

export const GAME_TYPES: GameType[] = [
  'NLH',
  'PLO', 
  'PLO8',
  'Mixed',
  'Stud',
  'Razz',
  'Stud8',
  'Custom'
];

export const TABLE_STATUSES: TableStatus[] = [
  'Open',
  'Running', 
  'Closed',
  'Interest'
];

